import { render } from "./GeneralDashboardLayout.vue?vue&type=template&id=9000c4d2&scoped=true"
import script from "./GeneralDashboardLayout.vue?vue&type=script&lang=js"
export * from "./GeneralDashboardLayout.vue?vue&type=script&lang=js"

import "./GeneralDashboardLayout.vue?vue&type=style&index=0&id=9000c4d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9000c4d2"]])

export default __exports__